export default {
	TOKEN_KEY: "token",
	REFRESH_TOKEN_KEY: "refresh-token",
	TOKEN_EXPIRED_KEY: "token-expired",
	HOOK_STORAGE_KEYS: {
		AUTH_DATA: "AuthData",
		GAME_DATA: "GameData",
		USER_DATA: "UserData",
		LANGUAGE_DATA: "LanguageData",
		SYSTEM_DATA: "SystemData",
		BONUS_DATA: "BonusData",
		LOYALTY_DATA: "LoyaltyData",
		BETS_DATA: "BetsData",
		TOURNAMENTS_DATA: "TournamentsData",
		GITBOOK_DATA: "GitbookData"
	},
	INDEX_DB_NAME: "blockasino-zustand-idb",
	INDEX_DB_STORE_NAME: "blockasino-zustand-store-idb",
	GOOGLE_RECAPTCHA_PRIVACY_POLICY_LINK: "https://policies.google.com/privacy",
	INDEX_DB_VERSION: 1,
	USE_GOOGLE_RECAPTCHA: true,
	sizes: {
		mobile: 767
	},
	CORE_URLS: {
		HOME: "/",
		NOT_FOUND: "/404"
	},
	GLOBAL_CONSTANTS: {
		ENV_STAGE: import.meta.env.VITE_ENV_STAGE,
		BACKEND_URL: import.meta.env.VITE_BACKEND_URL,
		BACKEND_API_URL: `${import.meta.env.VITE_BACKEND_URL}/api/v1`,
		LOCAL_STORAGE_PREFIX: import.meta.env.VITE_LOCAL_STORAGE_PREFIX,

		CHIPS_PROTOCOL_URL: import.meta.env.VITE_CHIPS_PROTOCOL_URL,
		RESPONSIBLE_GAMING_URL: import.meta.env.VITE_RESPONSIBLE_GAMING_URL,
		KYC_POLICY_URL: import.meta.env.VITE_KYC_POLICY_URL,
		AML_POLICY_URL: import.meta.env.VITE_AML_POLICY_URL,
		PRIVACY_POLICY_URL: import.meta.env.VITE_PRIVACY_POLICY_URL,
		TERMS_OF_SERVICE_URL: import.meta.env.VITE_TERMS_OF_SERVICE_URL,

		SOCIAL_X_URL: import.meta.env.VITE_SOCIAL_X_URL,
		SOCIAL_TELEGRAM_URL: import.meta.env.VITE_SOCIAL_TELEGRAM_URL,
		SOCIAL_INSTAGRAM_URL: import.meta.env.VITE_SOCIAL_INSTAGRAM_URL,

		DOCS_URL: import.meta.env.VITE_DOCS_URL,
		FAQ_URL: import.meta.env.VITE_FAQ_URL,

		GITBOOK_API_URL: import.meta.env.VITE_GITBOOK_API_URL,
		GITBOOK_API_KEY: import.meta.env.VITE_GITBOOK_API_KEY,
		GITBOOK_SPACE_ID: import.meta.env.VITE_GITBOOK_SPACE_ID,
		GITBOOK_RESPONSIBLE_GAMING_PAGE_ID: import.meta.env.VITE_GITBOOK_RESPONSIBLE_GAMING_PAGE_ID,
		GITBOOK_KYC_POLICY_PAGE_ID: import.meta.env.VITE_GITBOOK_KYC_POLICY_PAGE_ID,
		GITBOOK_AML_POLICY_PAGE_ID: import.meta.env.VITE_GITBOOK_AML_POLICY_PAGE_ID,
		GITBOOK_PRIVACY_POLICY_PAGE_ID: import.meta.env.VITE_GITBOOK_PRIVACY_POLICY_PAGE_ID,
		GITBOOK_TERMS_OF_SERVICE_PAGE_ID: import.meta.env.VITE_GITBOOK_TERMS_OF_SERVICE_PAGE_ID,

		SUPPORT_EMAIL: import.meta.env.VITE_SUPPORT_EMAIL,
		BLOCKASINO_ROOT_URL: import.meta.env.VITE_BLOCKASINO_ROOT_URL,

		DIGITAIN_SPORTS_URL: import.meta.env.VITE_DIGITAIN_SPORTS_URL,
		DIGITAIN_SPORTS_COPY_URL: import.meta.env.VITE_DIGITAIN_SPORTS_COPY_URL,
		DIGITAIN_SPORTS_ALTERNATIVE_URL: import.meta.env.VITE_DIGITAIN_SPORTS_ALTERNATIVE_URL,

		GOOGLE_RECAPTCHA_SITE_KEY: import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY
	}
};
